<script>
export default {
    inheritAttrs: false,
    props: {
        initial: {
            default: false,
        }
    },

    render() {
        return this.$slots.default({
            active: this.active,
            toggle: this.toggle,
            update: this.update,
            add: this.add,
            remove: this.remove,
        })
    },

    data() {
        return {
            active: this.initial,
        }
    },

    methods: {
        toggle() {
            this.active = !this.active;
        },
        update(value) {
            this.active = value;
        },
        remove(value) {
            if(Array.isArray(this.active)) {
                this.active.splice(this.active.indexOf(value), 1);
            }
        },
        add(value) {
            if(Array.isArray(this.active)) {
                this.active = [...this.active, value];
            }
        }
    }
}
</script>
